import React, { ReactElement } from 'react'

import Typography from '@material-ui/core/Typography'

export type ListProps = DBN.IReactDefaultProps

export default function UnorderedList({
  children,
  ...props
}: ListProps): ReactElement {
  return (
    <ul {...props}>
      {(() => {
        return React.Children.map(children, (child, index) => {
          return (
            <Typography component="li" key={index}>
              {child}
            </Typography>
          )
        })
      })()}
    </ul>
  )
}
